import { useTranslation } from 'react-i18next';
import { LocalizationProvider, MobileDateTimePicker, MobileDateTimePickerProps } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(updateLocale);
dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.updateLocale('en', {
    weekStart: 1,
});

export const DateTimePicker = (props: MobileDateTimePickerProps<Dayjs>) => {
    const { t } = useTranslation();

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDateTimePicker
                {...props}
                dayOfWeekFormatter={day => {
                    return t(day);
                }}
            />
        </LocalizationProvider>
    );
};
